(function (global) {
  'use strict';

  var PROPERTY_NAME = 'properties[_Wilbers PN]';

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function selected(value) {
    var option = normalize(value).replace(/\s*\(\+\$[^)]*\)/g, '').trim();
    return option !== '' && !/^(no|none|false|hook wrench|standard|std\.?|0)$/.test(option);
  }

  function editionCode(edition, sku, title) {
    var option = normalize(edition);
    var suffix = String(sku || '').replace(/^\d{3}-\d{4}-\d{2}/, '');
    if (!option) {
      if (/-blue(?:-|$)/i.test(suffix)) option = 'blueline';
      else if (/-nigh(?:t(?:line)?)?(?:-|$)/i.test(suffix)) option = 'nightline';
      else if (/-black(?:line)?(?:-|$)/i.test(suffix)) option = 'blackline';
      else if (/-race(?:line)?(?:-|$)/i.test(suffix)) option = 'raceline';
    }
    if (option.indexOf('blueline') !== -1 || option === 'blue') return 'B38b';
    if (option.indexOf('blackline') !== -1 || option === 'black') return 'B38s';
    if (option.indexOf('nightline') !== -1 || option === 'night' || option === 'nigh') {
      return /\bts\b|twin[ -]?shocks?|stereo/i.test(String(title || '') + ' ' + option) ? 'B38NT' : 'B38N';
    }
    return option.indexOf('raceline') !== -1 ? 'B38RFederbein' : '';
  }

  function shockDiameter(title, sku) {
    var type = String(title || '').match(/\b(?:type|typ)\s*(\d[34]\d)\b/i);
    if (!type) type = String(sku || '').match(/^(\d[34]\d)-/);
    return type ? (type[1].charAt(1) === '3' ? '36' : '46') : '';
  }

  function preloadCode(value, sku, title) {
    var option = normalize(value);
    if (option && !selected(option)) return '';
    var suffix = String(sku || '').replace(/^\d{3}-\d{4}-\d{2}/, '');
    var source = option || normalize(suffix);
    var diameter = shockDiameter(title, sku);
    if (!diameter) return '';
    if (/zf[ -]?pa|zfpa|(?:^|-)659(?:-|$)/.test(source)) return '659-00' + diameter;
    if (/x[ -]?pa|xpa/.test(source)) return '625-01' + diameter;
    if (/wilbers[ -]?pa|wpa|h[ -]?pa|hydraulic/.test(source)) return '625-00' + diameter;
    return '';
  }

  function buildPartNumber(config) {
    var sku = String(config.sku == null ? '' : config.sku).trim();
    var base = sku.match(/^(\d{3}-\d{4}-\d{2})(?:-|$)/);
    if (!base) return '';
    var parts = [base[1]];
    var edition = editionCode(config.edition, sku, config.title);
    var preload = preloadCode(config.preloadAdjuster, sku, config.title);
    if (edition) parts.push(edition);
    if (preload) parts.push(preload);
    if (selected(config.lengthAdjuster)) parts.push('629-0000');
    if (selected(config.powdercoatSpring)) parts.push('135-0100-00');
    if (selected(config.expediteBuild)) {
      parts.push(/twin|\bts\b/i.test(String(config.expediteType || config.title || '')) ? '135-0001TS' : '135-0001');
    }
    return parts.join(' + ');
  }

  function elementValue(form, names) {
    for (var index = 0; index < names.length; index += 1) {
      var element = form.elements.namedItem(names[index]);
      if (element && String(element.value == null ? '' : element.value).trim() !== '') return element.value;
    }
    return '';
  }

  function productOptionValue(product, variant, names) {
    if (!product || !Array.isArray(product.options) || !variant) return '';
    var options = variant.options || [variant.option1, variant.option2, variant.option3];
    for (var index = 0; index < product.options.length; index += 1) {
      var definition = product.options[index];
      var name = normalize(typeof definition === 'string' ? definition : definition && definition.name);
      if (names.indexOf(name) !== -1) return options[index] || '';
    }
    return '';
  }

  function readJson(form, selector) {
    var element = form.querySelector(selector);
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (error) { return null; }
  }

  function selectedVariant(form, product, suppliedVariant) {
    if (suppliedVariant) return suppliedVariant;
    var id = elementValue(form, ['id']);
    var variant = readJson(form, '[data-epm-selected-variant]');
    if (variant && (!id || String(variant.id) === String(id))) return variant;
    return product && Array.isArray(product.variants)
      ? product.variants.find(function (candidate) { return String(candidate.id) === String(id); }) || null
      : null;
  }

  function updateForm(form, suppliedVariant) {
    if (!form) return;
    var output = form.querySelector('[data-wilbers-pn]');
    if (!output) return;
    var product = readJson(form, '[data-epm-product-json]') || readJson(form, '[data-product-json]');
    var variant = selectedVariant(form, product, suppliedVariant);
    var partNumber = '';
    if (variant) {
      var option = function (names) { return productOptionValue(product, variant, names); };
      partNumber = buildPartNumber({
        sku: variant.sku,
        title: output.getAttribute('data-wilbers-product-title'),
        edition: option(['edition', 'finish']),
        preloadAdjuster: option(['preload adjuster', 'preload adjustment', 'federvorspannung']),
        lengthAdjuster: elementValue(form, ['properties[Length Adjuster]', 'properties[Length adjuster]'])
          || option(['length adjuster', 'length adjustment', 'ride height adjuster', 'höhenverstellung']),
        powdercoatSpring: elementValue(form, ['properties[Powdercoat Spring]']) || option(['powdercoat spring']),
        expediteBuild: elementValue(form, ['properties[Expedite Build]']),
        expediteType: elementValue(form, ['wilbers_expedite_choice']) === 'yes'
          ? (form.querySelector('[data-wilbers-expedite-label]') || {}).value : ''
      });
    }
    output.value = partNumber;
    output.disabled = !partNumber;
  }

  function syncFormData(event) {
    var form = event.currentTarget;
    updateForm(form);
    var output = form.querySelector('[data-wilbers-pn]');
    if (output && !output.disabled && output.value) event.formData.set(PROPERTY_NAME, output.value);
    else event.formData.delete(PROPERTY_NAME);
  }

  function bindForm(form) {
    if (!form || !form.querySelector('[data-wilbers-pn]')) return;
    updateForm(form);
    if (form.dataset.wilbersPnBound === 'true') return;
    form.addEventListener('formdata', syncFormData);
    form.dataset.wilbersPnBound = 'true';
  }

  global.WilbersPartNumberCoder = {
    buildPartNumber: buildPartNumber,
    editionCode: editionCode,
    preloadCode: preloadCode,
    shockDiameter: shockDiameter,
    updateForm: updateForm
  };

  if (typeof document === 'undefined') return;

  document.addEventListener('theme:variant:change', function (event) {
    var element = event.target;
    var wrapper = element && element.closest ? element.closest('product-form') : null;
    var form = element && element.matches && element.matches('[data-product-form]') ? element
      : wrapper ? wrapper.querySelector('[data-product-form]') : element && element.form;
    bindForm(form);
    updateForm(form, event.detail && event.detail.variant);
  });

  ['input', 'change'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var form = event.target && event.target.form;
      if (!form || !form.querySelector('[data-wilbers-pn]')) return;
      queueMicrotask(function () { bindForm(form); updateForm(form); });
    });
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-add-to-cart]') : null;
    if (button && button.form) bindForm(button.form);
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('[data-product-form]')) bindForm(event.target);
  }, true);

  function initialize(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-product-form]').forEach(bindForm);
  }

  if (global.addEventListener) global.addEventListener('theme:section:update', function () { initialize(); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(); });
  else initialize();
})(typeof window !== 'undefined' ? window : globalThis);
